import { SET_EINVOICE_DATA } from "../../constants";

import { createAction } from "../../utils";

const setEinvoiceData = createAction(SET_EINVOICE_DATA);

export const setEinvoiceDataInLocalStorage =
  (eInvoiceData) => (dispatch, getState) => {
    eInvoiceData
      ? window.localStorage.setItem(
          "eInvoiceData",
          JSON.stringify(eInvoiceData),
        )
      : window.localStorage.removeItem("eInvoiceData");

    return dispatch(setEinvoiceData(eInvoiceData));
  };
